export default "__VITE_ASSET__CDvgJkSr__"